import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ChartTooltip from "./ChartTooltip.jsx";
import { renderRotatedBarLabel } from "./BarLabel.jsx";
import {
  ChartCard,
  ChartNoDataFound,
  ChartsLegend,
  formatDate,
  useEffect,
  useState,
} from "@";
import { useClientsQuery, useNewOrdersQuery } from "../../utils/queries.js";

// Main StackedBarChart component
const Index = ({ legendItems, title, queryType = "clients" }) => {
  const [data, setData] = useState([]);
  const [searchDuration, setSearchDuration] = useState(3);

  // Select the appropriate query hook based on queryType
  const queries = {
    clients: useClientsQuery,
    newOrders: useNewOrdersQuery,
  };

  const useQueryHook = queries[queryType] || useClientsQuery;
  const { data: queryData } = useQueryHook(searchDuration);

  // Update the chart data based on the fetched results
  const updateData = (res) => {
    if (!res?.userPercentages) {
      setData([]);
      return;
    }
    const values = res.userPercentages.map((item) => ({
      key: formatDate(item.date),
      valueA: item.previousCustomersPercentage,
      valueB: item.newCustomersPercentage,
    }));
    const filteredValues = values.filter(
      ({ valueA, valueB }) => valueA > 0 || valueB > 0,
    );
    setData(filteredValues);
  };

  // Fetch data based on the duration
  const fetchData = (value) => {
    setSearchDuration(value);
  };

  useEffect(() => {
    if (queryData) {
      updateData(queryData);
    }
  }, [queryData]);

  return (
    <ChartCard title={title} searchDurationUpdated={fetchData}>
      <div className="h-80">
        {data?.length > 0 ? (
          <ResponsiveContainer
            width="100%"
            height="100%"
            style={{ direction: "ltr" }}
          >
            <BarChart margin={{ top: 50, left: -20 }} barSize={23} data={data}>
              {/* Tooltip for the chart */}
              <Tooltip content={<ChartTooltip legendItems={legendItems} />} />
              <CartesianGrid
                className="stroke-gray-100 dark:stroke-gray-700"
                strokeDasharray="0 0"
              />
              <YAxis
                tickFormatter={(value) => `${value.toFixed(0)}%`}
                fontSize={12}
                strokeWidth={0}
              />

              <XAxis
                // minTickGap={20}
                fontSize={11}
                dataKey="key"
                strokeWidth={0}
              />
              {/* Custom legend */}
              <Legend
                align="left"
                layout="centric"
                verticalAlign="top"
                content={<ChartsLegend legendItems={legendItems} />}
                wrapperStyle={{ position: "absolute", left: 0, top: 5 }}
              />
              {/* Bar for valueA */}
              <Bar
                label={renderRotatedBarLabel(data, "valueA")}
                stackId="a"
                fill="#570094"
                dataKey="valueA"
              />
              {/* Bar for valueB */}
              <Bar
                label={renderRotatedBarLabel(data, "valueB")}
                stackId="a"
                fill="#16BDCA"
                dataKey="valueB"
                radius={[50, 50, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <ChartNoDataFound />
        )}
      </div>
    </ChartCard>
  );
};

export default Index;
